function removeDiacritics(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function normalizeForSearch(text) {
    return removeDiacritics(text.toLowerCase());
}

export function filterBusSigns(items, searchText) {
    const search = normalizeForSearch((searchText || '').trim());
    if (!search) {
        return items;
    }
    return items.filter(item =>
        (item.serialNumber && normalizeForSearch(item.serialNumber).includes(search)) ||
        (item.busStopName && normalizeForSearch(item.busStopName).includes(search))
    );
}

export function getDistinctOperators(items) {
    const operatorsById = new Map();
    items.forEach(item => {
        if (item.operator && item.operator.id && !operatorsById.has(item.operator.id)) {
            operatorsById.set(item.operator.id, item.operator);
        }
    });
    return Array.from(operatorsById.values()).sort((a, b) => a.name.localeCompare(b.name));
}

export function filterBusSignsByOperator(items, operatorId) {
    if (!operatorId) {
        return items;
    }
    return items.filter(item => item.operator && item.operator.id === operatorId);
}
